/**
 * Shared has-data rule for a latest-metrics payload: true when ANY parameter
 * entry is non-null. Manual water-test entries land in the measurements table
 * the latest-metrics endpoint reads, so this flips for manual-only tanks too
 * (no device mapping required).
 *
 * Used by useGettingStarted (the latest-metrics half of its 'first-data'
 * checklist item — the full signal additionally ORs in device-mapped
 * parameters, which callers with their own device signal handle themselves)
 * and by MetricTilesGrid's no-enabled-parameters empty-state branching, so the
 * two can never drift apart on what counts as "data has arrived".
 *
 * Accepts any object-shaped payload (both call sites use differently-typed
 * views of the same endpoint response); null/undefined counts as no data.
 */
export function hasAnyMetricData(latest: object | null | undefined): boolean {
  return (
    !!latest && Object.values(latest).some((v) => v !== null && v !== undefined)
  );
}
